import React from 'react'
import { cn } from '@utils/safeTs'
import styles from './ChatAttachment.module.sass'
import { Attachment, Close } from '@components/icons'
import Link from 'next/link'
import useTrans from '@hooks/useTrans'


interface Props {
  attachment?: {
    url?: string
    label?: string
  }
  onRemove?: () => void
  className?: string
}

const ChatAttachment = (props: Props) => {

  const { 
    attachment,
    onRemove,
    className = '',
  } = props

  const t = useTrans()

  const getContent = () => (
    attachment.url ? (
      <Link href={attachment.url} target='_blank' download className={cn(styles.root, className)}>
        <Attachment />
        <span className={styles.label}>{attachment.label}</span>
      </Link>
    ) : (
      <span className={cn(styles.root, styles['root--nolink'], className)}>
        <Attachment />
        <span className={styles.label}>{attachment.label}</span>
      </span>
    )
  )

  return attachment ? (
    onRemove ? (
      <span className={styles.wrap}>
        {getContent()}
        <button type="button" aria-label={t("Rimuovi allegato {0}", [attachment.label])} onClick={onRemove} className={styles.remove}>
          <Close />
        </button>
      </span>
    ) : getContent()
  ) : <></>
}

export default ChatAttachment
